import { call, put, takeEvery, takeLatest, delay } from "redux-saga/effects"
import { addVehicleApi, approveVehicleSuggetionsAPI, rejectVehicleSuggetionsAPI, sendSuggestionEmailApi, viewVehicleSuggetionsAPI, changeActionAPI } from "./api";
import { addVehicleFail, addVehicleSuccess, approveVehicleSuggetionFail, approveVehicleSuggetionSuccess, rejectVehicleSuggestionFail, rejectVehicleSuggestionSuccess, sendSuggestionEmailFailed, sendSuggestionEmailSuccess, viewVehicleSuggestionsFail, viewVehicleSuggestionsSuccess, changeActionSuccess, changeActionFail } from "./actions";
import { ADD_VEHICLE, APPROVE_VEHICLE_SUGGESTIONS, REJECT_VEHICLE_SUGGESTIONS, SEND_SUGGESTION_EMAIL, VIEW_VEHICLE_SUGGESTIONS, CHANGE_ACTION } from "./Constants";


function* viewVehicleSuggetionsSaga(payload) {
    try {


        const response = yield call(viewVehicleSuggetionsAPI, payload.payload)
        if (response && response.data.status === 1) {
            yield put(viewVehicleSuggestionsSuccess(response.data.data))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(viewVehicleSuggestionsFail(error.response.data.message || "Unable to get vehicle suggestions"))
    }
}



function* approveVehicleSuggetionsSaga(payload) {
    try {


        const response = yield call(approveVehicleSuggetionsAPI, payload.payload)
        if (response && response.data.status === 1) {
            yield put(approveVehicleSuggetionSuccess(response.data.message))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(approveVehicleSuggetionFail(error.response.data.message || "Unable to Approve vehicle suggestions"))
    }
}



function* rejectVehicleSuggetionsSaga(payload) {
    try {
        const response = yield call(rejectVehicleSuggetionsAPI, payload.payload)
        if (response && response.data.status === 1) {
            yield put(rejectVehicleSuggestionSuccess(response.data.message))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(rejectVehicleSuggestionFail(error.response.data.message || "Unable to Reject vehicle suggestions"))
    }
}



function* addVehicleSaga(payload) {
    try {
        const response = yield call(addVehicleApi, payload.payload)
        if (response && response.data.status === 1) {
            yield put(addVehicleSuccess(response.data.message))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(addVehicleFail(error.response.data.message || "Unable to Reject vehicle suggestions"))
    }
}


function* sendSuggestionEmailSaga(action) {
    try {
        const response = yield call(sendSuggestionEmailApi, action.payload)
        if (response) {
            yield put(sendSuggestionEmailSuccess(response.data.message))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(sendSuggestionEmailFailed(error.response.data.message || "Unable to Reject vehicle suggestions"))
    }
}

function* changeActionSaga(payload) {
    try {
        const response = yield call(changeActionAPI, payload.payload)
        if (response && response.data.status === 1) {
            yield put(changeActionSuccess(response.data.message))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(changeActionFail(error.response.data.message || "Unable to change action suggestions"))
    }
}


function* VehicleMasterSaga() {

     yield takeEvery(VIEW_VEHICLE_SUGGESTIONS, viewVehicleSuggetionsSaga)
     yield takeEvery(APPROVE_VEHICLE_SUGGESTIONS, approveVehicleSuggetionsSaga)
     yield takeEvery(REJECT_VEHICLE_SUGGESTIONS, rejectVehicleSuggetionsSaga)
     yield takeEvery(ADD_VEHICLE, addVehicleSaga)
     yield takeEvery(SEND_SUGGESTION_EMAIL, sendSuggestionEmailSaga)
     yield takeEvery(CHANGE_ACTION, changeActionSaga)
   
    //yield takeLatest(LOGOUT_SU_USER, logoutUser)
}

export default VehicleMasterSaga;